/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { useEffect, useRef } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { loginState } from "../lib/State";
import CenterSelect from "./CenterSelect";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import WhatsNewModal from "./WhatsNewModal";

export default function WhatsNew() {
  const [login, setLogin] = useState(loginState);
  const [rows, setRows] = useState();
  const token = localStorage.getItem("token");
  const [tcid, setTcid] = useState("");
  const modalRef = useRef();

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록일", width: 120 },
    { field: "sdate", headerName: "시작일", width: 120 },
    { field: "edate", headerName: "종료일", width: 120 },
    {
      field: "menu_img",
      headerName: "이미지",
      width: 200,
      height: 150,
      renderCell: (props) => (
        <img
          src={props.value}
          css={css`
            width: 100%;
            height: 100%;
            object-fit: contain;
          `}
        />
      ),
    },
    { field: "title", headerName: "제목", flex: 1 },
    { field: "cname", headerName: "센터명", width: 180 },
  ];

  // 로그인
  useEffect(() => {
    const start = async () => {
      let result;
      result = await get_login();
      setLogin(result.data.login);
      result = await is_admin(result.data.login);
      if (!result) {
        window.location.href = "/";
      }
    };
    start();
  }, []);

  // 리스트
  const loadData = async () => {
    const result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/whatsnew_all`,
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
      }
    );
    if (!result?.data?.success) return Swal.fire(result.data.msg);
    setRows(result.data.rows);
  };

  // 리스트
  useEffect(() => {
    if (!login?.level) return;
    if (login.level === "500") return loadData();
    else if (tcid) return loadData();
  }, [login, tcid]);

  return !rows ? (
    <Loading></Loading>
  ) : (
    <Layout login={login}>
      <h3
        css={css`
          margin-top: 10px;
        `}
      >
        What's New
      </h3>
      <Box
        display="flex"
        css={css`
          text-align: right;
          max-width: 1300px;
          margin-bottom: 15px;
          justify-content: space-between;
        `}
      >
        {/* 센터명 */}
        <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
        <WhatsNewModal ref={modalRef} loadData={loadData} login={login}>
          <Button variant="contained" color="primary" startIcon={<AddIcon />}>
            추가
          </Button>
        </WhatsNewModal>
      </Box>

      <DataGrid
        css={css`
          max-width: 1300px;
          min-height: 500px;
        `}
        rowHeight={100}
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5, 10]}
        checkboxSelection={false}
        onRowClick={(params) => {
          modalRef.current(params.row.id);
        }}
        components={{ Toolbar: GridToolbar }}
      />
    </Layout>
  );
}
